<template>
  <div class="form-group row">
    <label
      for="lm-text-area"
      class="col-sm-2 col-form-label"
      >{{label}}</label>
    <div class="col-sm-10">
      <textarea
        v-model="textArea"
        :class="{'is-invalid': v.$error}"
        :readonly="readonly"
        :placeholder="placeholder"
        class="form-control"
        id="lm-text-area"
        rows="3"
        ></textarea>
        <p class="invalid-feedback" v-if="!v.required"> {{ $t('field_required')}} </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    v: {
      type: Object,
      required: true
    },
    readonly: Boolean,
    label: String,
    placeholder: String
  },
  computed: {
    textArea: {
      get () {
        return this.value
      },
      set (value) {
        this.v.$touch()
        this.$emit('input', value)
      }
    }
  }
}
</script>
